import React from 'react';
import { Stack, Link, Typography, Avatar } from '@mui/material';
import { useSelector } from 'src/redux/hooks';
import { fetchPrimaryPartnerManager } from 'src/services/APIs/isoAPI';
import { RM_AVATARS } from 'src/assets/rm-avatars';

export default function ContactRMWidget() {
  const client = useSelector((state) => state.admin.client);
  const [manager, setManager] = React.useState<{
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber?: string;
  } | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    const isoId = client?.isoId || localStorage.getItem('isoId') || '';
    if (!isoId) return;
    setLoading(true);
    fetchPrimaryPartnerManager(isoId)
      .then((pm) => setManager(pm))
      .finally(() => setLoading(false));
  }, [client?.isoId]);

  const fullName = manager ? `${manager.firstName} ${manager.lastName}` : '';
  const emailHref = manager ? `mailto:${manager.emailAddress}` : '#';

  if (!manager) return null;
  return (
    <Stack spacing={1}>
      <Link
        href={emailHref}
        underline="always"
        color="rgb(180, 180, 180)"
        sx={{ cursor: manager ? 'pointer' : 'default' }}
      >
        <Typography variant="overline">Contact Your RM</Typography>
      </Link>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Avatar src={manager?.emailAddress ? RM_AVATARS[manager.emailAddress] : undefined}>
          {manager?.firstName?.[0] ?? 'R'}
        </Avatar>
        <Stack>
          <Typography variant="subtitle2" color="rgb(255, 255, 255)">
            {loading ? 'Loading…' : fullName}
          </Typography>
          {manager?.phoneNumber && (
            <Link
              href={`tel:${manager.phoneNumber}`}
              color="rgb(255, 255, 255)"
              underline="none"
              variant="caption"
            >
              {manager?.phoneNumber}
            </Link>
          )}
          {manager && (
            <Link href={emailHref} color="rgb(220, 220, 220)" underline="none" variant="caption">
              {manager.emailAddress}
            </Link>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
